import React, { useState, useEffect } from "react";
import { Chart } from "primereact/chart";
import { ConvertMonthTH } from "../../widgets/form/ConvertTime";

const AmountGraph = ({ data }: any) => {
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const getAmount = () => {
      console.log("=== AmountGraph Debug ===");
      console.log("ข้อมูลที่ได้รับ (data):", data);

      // data จาก API มีโครงสร้าง [{ month: "2024-01", amount: "500.00" }, ...]
      // แปลง amount จาก string เป็น number
      const months = data.map((val: any) => ConvertMonthTH(val.month));
      const amounts = data.map((val: any) => {
        // ลบเครื่องหมายคอมม่าและแปลงเป็น number
        const cleanAmount = typeof val.amount === 'string'
          ? val.amount.replace(/,/g, '')
          : val.amount;
        return parseFloat(cleanAmount) || 0;
      });

      // หาค่าที่มากที่สุด
      const maxAmount = Math.max(...amounts);
      const maxIndex = amounts.indexOf(maxAmount);

      // สร้าง array ของสี โดยให้ค่าที่มากที่สุดเป็นสีเข้ม
      const backgroundColor = amounts.map((amount: number, index: number) => {
        return index === maxIndex ? '#2F457F' : '#547DE5';
      });

      const documentStyle = getComputedStyle(document.documentElement);
      const textColor = documentStyle.getPropertyValue("--text-color");
      const surfaceBorder = documentStyle.getPropertyValue("--surface-border");

      const graph_data = {
        labels: months,
        datasets: [
          {
            label: "จำนวนเงิน",
            data: amounts,
            fill: false,
            borderRadius: 6,
            backgroundColor: backgroundColor,
            tension: 0.4,
          },
        ],
      };

      const options = {
        maintainAspectRatio: false,
        aspectRatio: 0.6,
        plugins: {
          legend: {
            labels: {
              color: textColor,
              font: {
                family: "'Google Sans', sans-serif",
              },
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: "#BEC4D0",
              font: {
                family: "'Google Sans', sans-serif",
              },
            },
            grid: {
              color: surfaceBorder,
            },
          },
          y: {
            beginAtZero: true,
            ticks: {
              color: "#BEC4D0",
              font: {
                family: "'Google Sans', sans-serif",
              },
            },
            grid: {
              color: surfaceBorder,
            },
          },
        },
      };

      setChartData(graph_data);
      setChartOptions(options);
    };

    getAmount();
  }, [data]);

  return (
    <Chart
      type="bar"
      data={chartData}
      options={chartOptions}
      style={{ height: "320px" }}
    />
  );
};

export default AmountGraph;
